(() => {
  const API_URL = "https://auvenne-circle-production.up.railway.app/api/reviews";
  const requests = new Map();
  const language = (document.documentElement.lang || "nl").toLowerCase();
  const locale = language.startsWith("sv") ? "sv" : language.startsWith("en") ? "en" : "nl";
  const fallback = {
    nl: { retry: "Opnieuw laden", original: "In de oorspronkelijke taal", translated: "Vertaald uit het Nederlands", error: "Reviews kunnen nu niet worden geladen.", empty: "Er zijn nog geen reviews voor dit sieraad.", stars: "van 5 sterren", verified: "Geverifieerde aankoop", link: "Bekijk het sieraad", success: "Bedankt. Je review is ontvangen en wordt gecontroleerd.", submitError: "Versturen is niet bevestigd. Je invoer is bewaard; probeer het later opnieuw." },
    sv: { retry: "Försök igen", original: "På originalspråket", translated: "Översatt från nederländska", error: "Omdömena kan inte laddas just nu.", empty: "Det finns inga omdömen om det här smycket ännu.", stars: "av 5 stjärnor", verified: "Verifierat köp", link: "Se smycket", success: "Tack. Ditt omdöme har tagits emot och kommer att granskas.", submitError: "Det gick inte att bekräfta att omdömet skickades. Dina uppgifter finns kvar. Försök igen senare." },
    en: { retry: "Try again", original: "In the original language", translated: "Translated from Dutch", error: "Reviews cannot be loaded right now.", empty: "There are no reviews for this piece yet.", stars: "out of 5 stars", verified: "Verified purchase", link: "View the piece", success: "Thank you. Your review has been received and will be checked.", submitError: "We could not confirm your submission. Your details are saved here; please try again later." }
  };
  const copy = { ...fallback[locale], ...window.AUVENNEReviewCopy };
  // Existing reviews were written in Dutch. Translations are keyed by the exact original text,
  // so an edited or new review is shown in its original language instead of a stale translation.
  const translations = {
    "Heel verfijnd en precies de uitstraling die ik zocht. Staat mooi zonder te overheersen.": {
      "sv": "Väldigt elegant och precis den stil jag letade efter. Snygg utan att ta över.",
      "en": "Very refined and exactly the look I was after. Looks lovely without being overpowering."
    },
    "De verpakking voelde meteen luxe. Daardoor ook heel geschikt om cadeau te geven.": {
      "sv": "Förpackningen kändes lyxig direkt. Därför passar den också perfekt som present.",
      "en": "The packaging felt luxurious right away, which makes it a great gift too."
    },
    "Mooi product en netjes afgewerkt. Had hem persoonlijk iets groter verwacht, maar hij staat alsnog erg mooi.": {
      "sv": "Fin produkt och snyggt utförd. Jag hade själv väntat mig att den var lite större, men den är ändå väldigt fin.",
      "en": "Beautiful product with a neat finish. I personally expected it to be a little bigger, but it still looks really lovely."
    },
    "Op de foto al mooi, maar in het echt komt hij nog beter tot zijn recht.": {
      "sv": "Fin redan på bilden, men i verkligheten kommer den ännu mer till sin rätt.",
      "en": "Pretty in the photo already, but it looks even better in real life."
    },
    "Heel makkelijk te combineren met andere sieraden. Daardoor draag ik hem veel vaker dan verwacht.": {
      "sv": "Väldigt lätt att kombinera med andra smycken. Därför bär jag det mycket oftare än jag trodde.",
      "en": "Very easy to combine with other jewellery, so I wear it much more often than I expected."
    },
    "Minimalistisch maar toch speciaal. Heb al meerdere complimenten gekregen.": {
      "sv": "Minimalistisk men ändå speciell. Har redan fått flera komplimanger.",
      "en": "Minimalist but still special. I have already received several compliments."
    },
    "De kleur is echt mooi en niet overdreven geel. Ziet er chic uit.": {
      "sv": "Färgen är verkligen fin och inte överdrivet gul. Ser elegant ut.",
      "en": "The colour is really beautiful and not overly yellow. Looks chic."
    },
    "Gekocht voor een verjaardag en de ontvanger was er superblij mee.": {
      "sv": "Köpt till en födelsedag och mottagaren blev jätteglad.",
      "en": "Bought for a birthday and the recipient was delighted with it."
    },
    "Heel mooi, alleen moest ik even wennen aan de sluiting. Verder helemaal tevreden.": {
      "sv": "Väldigt fint, jag behövde bara vänja mig lite vid låset. I övrigt helt nöjd.",
      "en": "Very pretty, I just needed a moment to get used to the clasp. Otherwise completely happy."
    },
    "Dit is zo’n item dat je zowel casual als netjes kunt dragen. Heel veelzijdig.": {
      "sv": "Det här är ett sådant smycke som fungerar både till vardags och till finare tillfällen. Väldigt mångsidigt.",
      "en": "This is one of those pieces you can wear both casually and dressed up. Very versatile."
    },
    "Mooie subtiele glans. Niet te opvallend, precies goed.": {
      "sv": "Fin, diskret glans. Inte för iögonfallande, precis lagom.",
      "en": "Lovely subtle shine. Not too eye-catching, just right."
    },
    "Heel elegant ontwerp. Mijn vriendin dacht dat hij veel duurder was.": {
      "sv": "Väldigt elegant design. Min väninna trodde att det var mycket dyrare.",
      "en": "Very elegant design. My friend thought it was much more expensive."
    },
    "Heel tevreden. Precies chic genoeg zonder dat het overdreven wordt.": {
      "sv": "Väldigt nöjd. Precis lagom elegant utan att det blir för mycket.",
      "en": "Very happy. Just chic enough without being over the top."
    },
    "Staat mooi op zichzelf maar ook gecombineerd met andere sieraden.": {
      "sv": "Snyggt på egen hand men också tillsammans med andra smycken.",
      "en": "Looks lovely on its own but also combined with other jewellery."
    },
    "Mooi sieraad en comfortabele pasvorm. Zeker tevreden voor deze prijs.": {
      "sv": "Fint smycke med bekväm passform. Absolut nöjd för det här priset.",
      "en": "Beautiful piece with a comfortable fit. Definitely happy for this price."
    },
    "Had niet verwacht dat ik hem zo vaak zou dragen. Past letterlijk overal bij.": {
      "sv": "Hade inte trott att jag skulle bära det så ofta. Passar bokstavligen till allt.",
      "en": "Did not expect to wear it this often. Goes with literally everything."
    }
  };
  const normalizeText = (value) => String(value || "").replace(/\s+/g, " ").trim();
  const knownDutch = (text) => Object.prototype.hasOwnProperty.call(translations, normalizeText(text));
  const translatedText = (text) => (locale === "nl" ? null : translations[normalizeText(text)]?.[locale] || null);
  const reviewNote = (text, root) => {
    if (translatedText(text)) return copy.translated;
    if (locale === "nl" && knownDutch(text)) return "";
    return root?.dataset?.originalLabel || copy.original;
  };
  const make = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined && text !== null) node.textContent = text;
    return node;
  };
  const all = (scope, selector) => [...(scope.matches?.(selector) ? [scope] : []), ...scope.querySelectorAll(selector)];
  const rootPath = () => {
    const path = window.Shopify?.routes?.root || (locale === "sv" ? "/sv-se/" : "/");
    return "/" + String(path).replace(/^\/+|\/+$/g, "") + (path === "/" ? "" : "/");
  };
  const ratingValue = (value) => Number.isFinite(Number(value)) && Number(value) >= 1 && Number(value) <= 5;
  const formatRating = (value) => new Intl.NumberFormat(language, { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(Number(value));
  const summaryLabel = (root, summary) => (root.dataset.ratingTemplate || "{rating} / 5")
    .replaceAll("{rating}", formatRating(summary.average))
    .replaceAll("{count}", new Intl.NumberFormat(language).format(Number(summary.count)));
  const hasSnapshot = (root) => root.dataset.auvSnapshotValid === "true";
  const checkedSummary = (data) => {
    const summary = data?.summary;
    if (!summary || !Number.isInteger(summary.count) || summary.count < 0 || (summary.count > 0 && !ratingValue(summary.average))) throw new Error("Invalid review summary");
    return summary;
  };
  const starMeter = (value) => {
    const meter = make("span", "auv-star-meter");
    meter.setAttribute("role", "img");
    meter.setAttribute("aria-label", formatRating(value) + " " + copy.stars);
    const base = make("span", "auv-star-meter__base", "★★★★★");
    const fill = make("span", "auv-star-meter__fill", "★★★★★");
    base.setAttribute("aria-hidden", "true");
    fill.setAttribute("aria-hidden", "true");
    fill.style.width = Math.max(0, Math.min(100, Number(value) * 20)) + "%";
    meter.append(base, fill);
    return meter;
  };
  const setStars = (target, value) => target?.replaceChildren(starMeter(value));
  const fetchJSON = async (url, options = {}) => {
    const controller = new AbortController();
    const timer = window.setTimeout(() => controller.abort(), 8000);
    try {
      const response = await fetch(url, { mode: "cors", ...options, signal: controller.signal, headers: { Accept: "application/json", ...options.headers } });
      if (!response.ok) throw new Error("Review request failed");
      return await response.json();
    } finally {
      window.clearTimeout(timer);
    }
  };
  const getReviews = (query) => {
    if (!requests.has(query)) requests.set(query, fetchJSON(API_URL + "?" + query).catch((error) => { requests.delete(query); throw error; }));
    return requests.get(query);
  };
  const productReviews = (productId) => getReviews("productId=" + encodeURIComponent(productId));
  const validReviews = (data) => {
    if (!Array.isArray(data?.reviews)) throw new Error("Invalid review response");
    return data.reviews.filter((review) => review && ratingValue(review.rating) && typeof review.body === "string" && review.body.trim());
  };
  const showError = (list, root, retry) => {
    const panel = make("div", "auv-reviews__error");
    panel.dataset.auvReviewError = "true";
    panel.setAttribute("role", "status");
    panel.append(make("p", "", root.dataset.errorLabel || copy.error));
    const button = make("button", "auv-reviews__retry", root.dataset.retryLabel || copy.retry);
    button.type = "button";
    button.addEventListener("click", () => { button.disabled = true; retry(); }, { once: true });
    panel.append(button);
    root.querySelectorAll("[data-auv-review-error]").forEach((node) => node.remove());
    if (list.querySelector("[data-auv-server-review], [data-auv-live-review]")) {
      root.dataset.auvReviewRefresh = "unavailable";
    } else list.replaceChildren(panel);
  };
  const originalText = (tag, className, text, review) => {
    const node = make(tag, className, text);
    node.setAttribute("translate", "no");
    node.classList.add("notranslate");
    const sourceLocale = String(review.locale || review.language || "");
    if (/^[a-z]{2,3}(?:-[a-zA-Z]{2,4})?$/.test(sourceLocale)) node.lang = sourceLocale;
    return node;
  };
  const reviewText = (tag, className, text, review) => {
    const translated = translatedText(text);
    if (!translated) return originalText(tag, className, text, review);
    const node = make(tag, className, translated);
    node.setAttribute("translate", "no");
    node.classList.add("notranslate");
    node.lang = locale;
    return node;
  };
  const appendNote = (card, text, root) => {
    const note = reviewNote(text, root);
    if (note) card.append(make("p", "auv-review-card__original", note));
  };
  const renderProductCard = (review, root) => {
    const card = make("article", "auv-review-card");
    card.dataset.auvLiveReview = String(review.id || "published");
    const top = make("div", "auv-review-card__top");
    const meta = make("div", "auv-review-card__meta");
    if (review.verifiedPurchase === true) meta.append(make("span", "", root.dataset.verifiedLabel || copy.verified));
    top.append(starMeter(review.rating), meta);
    card.append(top);
    if (review.title) card.append(originalText("h3", "auv-review-card__title", review.title, review));
    card.append(reviewText("p", "auv-review-card__body", review.body, review));
    appendNote(card, review.body, root);
    return card;
  };
  const dialogControls = (root) => {
    const dialog = root.querySelector("[data-auv-review-dialog]");
    const open = root.querySelector("[data-auv-review-open]");
    const close = root.querySelector("[data-auv-review-close]");
    const form = root.querySelector("[data-auv-review-form]");
    if (!dialog || !open || !close || !form || form.dataset.auvBound) return;
    form.dataset.auvBound = "true";
    let startedAt = 0;
    open.addEventListener("click", () => { startedAt = Date.now(); if (!dialog.open) dialog.showModal(); });
    close.addEventListener("click", () => dialog.close());
    dialog.addEventListener("close", () => open.focus({ preventScroll: true }));
    dialog.addEventListener("click", (event) => {
      if (event.target !== dialog) return;
      const bounds = dialog.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
    });
    const radios = [...form.querySelectorAll('input[name="rating"]')];
    const paintStars = () => radios.forEach((radio) => radio.nextElementSibling?.classList.toggle("is-active", Number(radio.value) <= Number(form.elements.rating?.value || 0)));
    radios.forEach((radio) => radio.addEventListener("change", paintStars));
    form.addEventListener("submit", async (event) => {
      event.preventDefault();
      if (form.dataset.submitting === "true") return;
      const status = form.querySelector("[data-auv-form-status]");
      const submit = form.querySelector('[type="submit"]');
      if (!status || !submit || !form.reportValidity()) return;
      status.classList.remove("is-error");
      status.textContent = "";
      const values = new FormData(form);
      const payload = { productId: root.dataset.productId, productHandle: root.dataset.productHandle, productTitle: root.dataset.productTitle, startedAt };
      ["rating", "authorName", "authorEmail", "title", "body", "website"].forEach((key) => { payload[key] = values.get(key); });
      form.dataset.submitting = "true";
      submit.disabled = true;
      try {
        await fetchJSON(API_URL, { body: JSON.stringify(payload), headers: { "Content-Type": "application/json" }, method: "POST" });
        status.textContent = root.dataset.successLabel || copy.success;
        form.reset();
        paintStars();
      } catch {
        status.classList.add("is-error");
        status.textContent = root.dataset.submitErrorLabel || copy.submitError;
      } finally {
        delete form.dataset.submitting;
        submit.disabled = false;
      }
    });
  };
  const translateServerReviews = (scope) => {
    all(scope, "[data-auv-server-review]:not([data-auv-review-localized])").forEach((card) => {
      card.dataset.auvReviewLocalized = "true";
      const body = card.querySelector(".auv-home-review__body");
      const note = card.querySelector(".auv-review-card__original");
      if (!body) return;
      const original = body.textContent;
      const translated = translatedText(original);
      if (translated) {
        body.textContent = translated;
        body.lang = locale;
      }
      const label = reviewNote(original, null);
      if (!note) return;
      if (label) note.textContent = label;
      else note.remove();
    });
  };
  const init = (scope = document) => {
    translateServerReviews(scope);
    all(scope, "[data-auv-overall-rating]:not([data-auv-ready])").forEach((root) => {
      root.dataset.auvReady = "true";
      getReviews("overall=true").then((data) => {
        const average = checkedSummary(data).average;
        const label = root.querySelector("[data-auv-overall-label]");
        if (!(Number(data?.summary?.count) > 0) || !ratingValue(average) || !label) { root.hidden = true; return; }
        const message = summaryLabel(root, data.summary);
        setStars(root.querySelector("[data-auv-overall-stars]"), average);
        root.querySelectorAll("[data-auv-overall-value]").forEach((node) => { node.textContent = formatRating(average); });
        label.textContent = message;
        root.removeAttribute("aria-label");
        root.dataset.auvRefreshedAt = new Date().toISOString();
        root.removeAttribute("title");
        root.hidden = false;
      }).catch(() => { if (!hasSnapshot(root)) root.hidden = true; delete root.dataset.auvReady; });
    });
    all(scope, "[data-auv-review-summary]:not([data-auv-ready])").forEach((summary) => {
      summary.dataset.auvReady = "true";
      const stars = summary.querySelector("[data-auv-summary-stars]");
      const label = summary.querySelector("[data-auv-summary-label]");
      productReviews(summary.dataset.productId).then((data) => {
        checkedSummary(data);
        const count = Number(data?.summary?.count || 0);
        const average = data?.summary?.average;
        summary.dataset.auvReviewCount = String(count);
        summary.hidden = !(count > 0 && ratingValue(average));
        if (summary.hidden) { stars?.replaceChildren(); return; }
        setStars(stars, average);
        if (label) label.textContent = summaryLabel(summary, data.summary);
        summary.dataset.auvRefreshedAt = new Date().toISOString();
        summary.removeAttribute("title");
      }).catch(() => { if (!hasSnapshot(summary)) summary.hidden = true; delete summary.dataset.auvReady; });
      if (summary.dataset.auvClickBound) return;
      summary.dataset.auvClickBound = "true";
      summary.addEventListener("click", (event) => {
        const href = summary.getAttribute("href") || "";
        const target = href.startsWith("#") ? document.getElementById(href.slice(1)) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: window.matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
      });
    });
    all(scope, "[data-auv-product-reviews]:not([data-auv-ready])").forEach((root) => {
      const list = root.querySelector("[data-auv-review-list]");
      if (!list) return;
      root.dataset.auvReady = "true";
      dialogControls(root);
      const score = root.querySelector("[data-auv-review-score]");
      const load = () => {
        list.setAttribute("aria-busy", "true");
        if (score && !list.querySelector("[data-auv-live-review]")) score.hidden = true;
        productReviews(root.dataset.productId).then((data) => {
          const reviews = validReviews(data);
          root.querySelectorAll("[data-auv-review-error]").forEach((node) => node.remove());
          list.replaceChildren();
          if (!reviews.length) {
            root.hidden = true;
            return;
          }
          root.hidden = false;
          reviews.forEach((review) => list.append(renderProductCard(review, root)));
          if (score && Number(data?.summary?.count) > 0 && ratingValue(data.summary.average)) {
            setStars(score.querySelector("[data-auv-score-stars]"), data.summary.average);
            const label = score.querySelector("[data-auv-score-label]");
            if (label) label.textContent = formatRating(data.summary.average) + " / 5";
            score.hidden = false;
          }
        }).catch(() => showError(list, root, load)).finally(() => list.setAttribute("aria-busy", "false"));
      };
      load();
    });
    all(scope, "[data-auv-home-reviews]:not([data-auv-ready])").forEach((root) => {
      const list = root.querySelector("[data-auv-home-review-list]");
      if (!list) return;
      root.dataset.auvReady = "true";
      if (root.hasAttribute("data-auv-reviews-static") && list.querySelector("[data-auv-server-review]")) return;
      const load = () => {
        list.setAttribute("aria-busy", "true");
        getReviews("featured=true").then((data) => {
          const reviews = validReviews(data).slice(0, 3);
          root.querySelectorAll("[data-auv-review-error]").forEach((node) => node.remove());
          list.replaceChildren();
          if (!reviews.length) list.append(make("p", "auv-reviews__empty", root.dataset.emptyLabel || copy.empty));
          reviews.forEach((review) => {
            const validHandle = /^[a-z0-9][a-z0-9-]*$/i.test(review.productHandle || "");
            const card = make(validHandle ? "a" : "article", "auv-home-review");
            card.dataset.auvLiveReview = String(review.id || "published");
            if (validHandle) card.href = rootPath() + "products/" + encodeURIComponent(review.productHandle) + "#auvenne-reviews";
            card.append(starMeter(review.rating), reviewText("p", "auv-home-review__body", review.body, review));
            appendNote(card, review.body, root);
            if (review.verifiedPurchase === true) card.append(make("span", "auv-home-review__verified", root.dataset.verifiedLabel || copy.verified));
            if (validHandle) {
              const product = make("span", "auv-home-review__product");
              product.append(make("span", "", review.productTitle), make("span", "", "→"));
              product.setAttribute("aria-label", (root.dataset.linkLabel || copy.link) + ": " + review.productTitle);
              card.append(product);
            }
            list.append(card);
          });
        }).catch(() => showError(list, root, load)).finally(() => list.setAttribute("aria-busy", "false"));
      };
      load();
    });
  };
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", () => init(), { once: true });
  else init();
  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
